import React from 'react';
import { TableRow } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { IOffBalanceLiabilityRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/offBalanceLiabilities/types.ts';
import {
  filterBankOptions,
  normalizeDecimalValue,
  normalizePercentageValue,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const OffBalanceLiabilityRow: React.FC<IOffBalanceLiabilityRowProps> = ({
  index,
  canRemove,
  disabled,
  creditorOptions,
  currencyOptions,
  isBanksLoading,
  isCurrenciesLoading,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`offBalanceLiabilities.${index}.debtor`}
        label="Боржник"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`offBalanceLiabilities.${index}.creditor`}
        label="Кредитор"
        options={creditorOptions}
        loading={isBanksLoading}
        filterOptions={filterBankOptions}
        shouldSaveLabel
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`offBalanceLiabilities.${index}.obligationType`}
        label="Вид зобов’язання"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`offBalanceLiabilities.${index}.currency`}
        label="Валюта"
        options={currencyOptions}
        loading={isCurrenciesLoading}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`offBalanceLiabilities.${index}.limitAmount`}
        label="Ліміт, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`offBalanceLiabilities.${index}.actualAmount`}
        label="Фактична сума, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`offBalanceLiabilities.${index}.interestRate`}
        label="Процентна ставка, %"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizePercentageValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`offBalanceLiabilities.${index}.openDate`}
        label="Дата відкриття"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`offBalanceLiabilities.${index}.endDate`}
        label="Дата завершення"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити зобов’язання ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
